// extracted by mini-css-extract-plugin
module.exports = {"rotate":"ExternalImageViewer_rotate__34-bE","container":"ExternalImageViewer_container__2iVlc"};